import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import styled from "styled-components";
import { Form, DatePicker, Button, Radio, Select } from "antd";
import FromControl from "../../component/form/FormControl";

import ReduxActions from "../../redux/actions";
import CompareGraphService from "../../service/compare-graph";

import moment from "moment";
import "moment/locale/th";
moment.locale("th");

const FormExtend = styled(FromControl)`
  width: 49.5%;
  height: 100%;
  border: 1px solid lightgray;
  border-radius: 5px;
  padding: 0px 20px;

  .form-item__from,
  .form-item__to,
  .form-item__offset {
    width: 31%;
    margin-right: 10px;

    @media only screen and (max-width: 1000px) {
      width: 45%;
    }

    @media only screen and (max-width: 500px) {
      width: 100%;
    }
  }

  .form-button-radio {
    width: 100%;
  }

  .form-button.guild-date {
    display: flex;
    flex-direction: column;
  }
`;

export default function Index(props) {
  const selectedParams = useSelector(
    (state) => state.compareGraph.selectedParams
  );
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [freeRangeDateTime, setFreeRangeDateTime] = useState(true);

  useEffect(() => {
    form.setFieldsValue({
      from: moment(new Date()).add(-1, "days").set({ hour: 0, minute: 0 }),
      to: moment(new Date()).set({ hour: 0, minute: 0 }),
      pattern: "15m",
      timeSet: "1d",
      offset: false,
    });

    const inti = async () => {};

    let formValue = form.getFieldsValue();
    props.setFormSearch(formValue);
  }, [form]);

  const onFinish = async (values) => {
    let params = [];
    selectedParams.map((sp) => {
      params.push(sp.id);
    });
    dispatch(ReduxActions.compareGraph.setGraphRendering(true));
    if (props.setFormSearch) {
      props.setFormSearch(values);
    }
    let graphData = await CompareGraphService.graphData(
      params,
      moment(form.getFieldValue("from")).format("YYYY-MM-DD HH:mm"),
      moment(form.getFieldValue("to")).format("YYYY-MM-DD HH:mm"),
      form.getFieldValue("pattern"),
      form.getFieldValue("offset"),
      values.offset
    );
    dispatch(
      ReduxActions.compareGraph.setGraphData(graphData ? graphData : [])
    );
    dispatch(ReduxActions.compareGraph.setGraphRendering(false));
  };

  const onClickDateGuild = (e) => {
    if (e.target.value == "1h")
      form.setFieldsValue({
        to: moment(new Date()).set({ hour: 0, minute: 0 }),
        from: moment(new Date()).set({ hour: 0, minute: 0 }).add(-1, "hours"),
      });
    if (e.target.value == "6h")
      form.setFieldsValue({
        to: moment(new Date()).set({ hour: 0, minute: 0 }),
        from: moment(new Date()).set({ hour: 0, minute: 0 }).add(-6, "hours"),
      });
    if (e.target.value == "12h")
      form.setFieldsValue({
        to: moment(new Date()).set({ hour: 0, minute: 0 }),
        from: moment(new Date()).set({ hour: 0, minute: 0 }).add(-12, "hours"),
      });
    if (e.target.value == "1d")
      form.setFieldsValue({
        to: moment(new Date()).set({ hour: 0, minute: 0 }),
        from: moment(new Date()).set({ hour: 0, minute: 0 }).add(-1, "days"),
      });
    if (e.target.value == "7d")
      form.setFieldsValue({
        to: moment(new Date()).set({ hour: 0, minute: 0 }),
        from: moment(new Date()).set({ hour: 0, minute: 0 }).add(-7, "days"),
      });
    if (e.target.value == "14d")
      form.setFieldsValue({
        to: moment(new Date()).set({ hour: 0, minute: 0 }),
        from: moment(new Date()).set({ hour: 0, minute: 0 }).add(-14, "days"),
      });
    if (e.target.value == "30d")
      form.setFieldsValue({
        to: moment(new Date()).set({ hour: 0, minute: 0 }),
        from: moment(new Date()).set({ hour: 0, minute: 0 }).add(-30, "days"),
      });

    if (e.target.value === 0) {
      setFreeRangeDateTime(false);
    } else {
      setFreeRangeDateTime(true);
    }
  };

  const formInput = () => {
    return (
      <>
        <Form.Item
          name={["from"]}
          className="form-item__from"
          label="ค้นหาจากช่วงวันเวลา"
        >
          <DatePicker
            disabled={freeRangeDateTime}
            showTime={{ format: "HH:mm" }}
            format="YYYY-MM-DD HH:mm"
          />
        </Form.Item>
        <Form.Item
          name={["to"]}
          className="form-item__to"
          label="ค้นหาถึงช่วงวันเวลา"
        >
          <DatePicker
            disabled={freeRangeDateTime}
            showTime={{ format: "HH:mm" }}
            format="YYYY-MM-DD HH:mm"
          />
        </Form.Item>
        <Form.Item
          name={["offset"]}
          className="form-item__offset"
          label="วิธีการคำนวณค่าระดับน้ำ"
        >
          <Select onChange={() => {}}>
            <Select.Option value={false}>
              ค่าระดับน้ำวัดเทียบจากศูนย์บรรทัดน้ำ
            </Select.Option>
            <Select.Option value={true}>
              ค่าระดับน้ำที่หักค่าเกณฑ์หักน้ำแล้ว
            </Select.Option>
          </Select>
        </Form.Item>
        <Form.Item className="form-button-radio" name="timeSet">
          <Radio.Group
            className="date-time-selector"
            onChange={onClickDateGuild}
          >
            <Radio value={0}>กำหนดเอง</Radio>
            <Radio value={"1h"}>1 ชั่วโมง</Radio>
            <Radio value={"6h"}>6 ชั่วโมง</Radio>
            <Radio value={"12h"}>12 ชั่วโมง</Radio>
            <Radio value={"1d"}>1 วัน</Radio>
            <Radio value={"7d"}>7 วัน</Radio>
            <Radio value={"14d"}>14 วัน</Radio>
            <Radio value={"30d"}>30 วัน</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item
          className="form-button-radio"
          name={["pattern"]}
          label="รูปแบบ"
        >
          <Radio.Group className="date-time-selector" onChange={() => {}}>
            <Radio value={"1m"}>1 นาที</Radio>
            <Radio value={"5m"}>5 นาที</Radio>
            <Radio value={"15m"}>15 นาที</Radio>
            <Radio value={"30m"}>30 นาที</Radio>
            <Radio value={"1h"}>1 ชั่วโมง</Radio>
            <Radio value={"4h"}>4 ชั่วโมง</Radio>
            <Radio value={"12h"}>12 ชั่วโมง</Radio>
            <Radio value={"1d"}>1 วัน</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item className="form-button">
          <Button
            className="form-item__btn-submit btn-primary btn-primary"
            htmlType="submit"
          >
            ค้นหา
          </Button>
        </Form.Item>
      </>
    );
  };

  return (
    <>
      <FormExtend
        name={"form-line-chart-option"}
        column={1}
        inputs={formInput}
        onFinish={props.onFinish ? props.onFinish : onFinish}
        form={form}
        className={props.className ? props.className : ""}
      />
    </>
  );
}
